import axios from "axios";
import API_MAP from "../../services/uri";
import errorHandler from "./errorHandler";

export const fetchNotifications = async ({ page }) => {
	try {
		const response = await axios.get(
			`${API_MAP.notifications}?page=${page}&paginate=15`
		);
		return response.data.data;
	} catch (error) {
		console.log(
			"=====>Fetch notification response<====\n",
			error,
			"\n",
			error.response
		);
		return errorHandler(error);
	}
};
